module.exports = __webpack_public_path__ + "img/dashboard.9c07d3af.svg";